module.exports = __webpack_public_path__ + "media/application/images/services/secondary_nav/minerals-dd61143a5fcefbc89b3242ca18dec8cf.jpg";